export default __webpack_public_path__ + "static/media/favicon-03.0f9ca8fe.svg";